const SIGN_IN_PATH = '/auth/signin';
// Paths that must not be round-tripped back through sign-in as a callbackUrl:
// - /auth/*           : sign-in / callback routes; using one as the callback loops.
// - /ms-office-addin/*: popup auth handshake is same-origin only (see
//   redirectToEnterpriseOrigin.ts); a callbackUrl pointing here breaks the popup.
const EXCLUDED_CALLBACK_PREFIXES = ['/auth/', '/ms-office-addin/'];
/**
 * Builds the single-tenant gate's sign-in redirect, preserving the user's
 * current location as a `callbackUrl` so a deep link (e.g. /computer/a/<id>)
 * survives the sign-in round trip instead of dropping the user on `/`.
 *
 * Returns a bare `/auth/signin` (no callbackUrl) for paths that must not be
 * round-tripped, or for anything that isn't a plain same-site path. The
 * callbackUrl is the user's own same-site path; the sign-in page re-validates
 * it via cleanQueryRedirect (same-origin or `/`) before honoring it, so this is
 * purely a convenience carrier, not a trust boundary.
 */
export function buildSignInRedirect(pathname, search = '') {
    // Reject anything that isn't a plain absolute path (incl. protocol-relative
    // "//evil.com") so we never carry an off-site or malformed callbackUrl.
    if (!pathname.startsWith('/') || pathname.startsWith('//')) {
        return SIGN_IN_PATH;
    }
    if (EXCLUDED_CALLBACK_PREFIXES.some((prefix) => pathname.startsWith(prefix))) {
        return SIGN_IN_PATH;
    }
    const params = new URLSearchParams({ callbackUrl: `${pathname}${search}` });
    return `${SIGN_IN_PATH}?${params.toString()}`;
}
//# sourceMappingURL=buildSignInRedirect.js.map